import Dictionary from '@/types/dictionary';
import PERIOD_END_DATA_OPTIONS from '@/types/period-end-data-options';

export type UserPreferencesComparisonSettingOption = {
  value: string;
  i18nKey: string;
  hidden?: boolean;
};

export enum USER_PREFERENCES_INITIAL_BENCHMARK {
  CATEGORY_BENCHMARK = 'CATEGORY_BENCHMARK',
  NO_BENCHMARK = 'NO_BENCHMARK',
}

export enum USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_DETAIL {
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_HORIZON {
  YTD = 'YTD',
  '1Y' = '1Y',
  '3Y' = '3Y',
  '5Y' = '5Y',
  '10Y' = '10Y',
  INC = 'INC',
}

export const USER_PREFERENCES_COMPARISON_SETTINGS: Dictionary<UserPreferencesComparisonSettingOption[]> = {
  BASE_CURRENCY: [
    {
      value: 'Yes',
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.BaseCurrency.Options.Yes',
    },
    {
      value: 'No',
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.BaseCurrency.Options.No',
    },
  ],
  HYPOTHETICAL_RETURN_CHART_DETAIL: [
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_DETAIL.WEEKLY,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartDetail.Options.WeeklyData',
    },
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_DETAIL.MONTHLY,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartDetail.Options.MonthlyData',
    },
  ],
  HYPOTHETICAL_RETURN_CHART_HORIZON: [
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_HORIZON.YTD,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartHorizon.Options.YTD',
    },
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_HORIZON['1Y'],
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartHorizon.Options.1Y',
    },
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_HORIZON['3Y'],
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartHorizon.Options.3Y',
    },
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_HORIZON['5Y'],
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartHorizon.Options.5Y',
    },
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_HORIZON['10Y'],
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartHorizon.Options.10Y',
    },
    {
      value: USER_PREFERENCES_HYPOTHETICAL_RETURN_CHART_HORIZON.INC,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.HypotheticalReturnChartHorizon.Options.CI',
    },
  ],
  INITIAL_BENCHMARK: [
    {
      value: USER_PREFERENCES_INITIAL_BENCHMARK.CATEGORY_BENCHMARK,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.InitialBenchmark.Options.CategoryBenchmark',
    },
    {
      value: USER_PREFERENCES_INITIAL_BENCHMARK.NO_BENCHMARK,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.InitialBenchmark.Options.NoBenchmark',
    },
  ],
  PERFORMANCE_AND_RISK_DATA: [
    {
      value: PERIOD_END_DATA_OPTIONS.NONE,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.PerformanceAndRiskData.Options.MostRecent',
    },
    {
      value: PERIOD_END_DATA_OPTIONS.RECENT_MONTH_END,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.PerformanceAndRiskData.Options.MostRecentMonthEnd',
    },
    {
      value: PERIOD_END_DATA_OPTIONS.PREVIOUS_MONTH_END,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.PerformanceAndRiskData.Options.PreviousMonthEnd',
    },
    {
      value: PERIOD_END_DATA_OPTIONS.RECENT_QUARTER_END,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.PerformanceAndRiskData.Options.MostRecentQuarterEnd',
    },
    {
      value: PERIOD_END_DATA_OPTIONS.PREVIOUS_QUARTER_END,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.PerformanceAndRiskData.Options.PreviousQuarterEnd',
    },
    {
      value: PERIOD_END_DATA_OPTIONS.AUTO,
      i18nKey: 'Settings.Preferences.ComparisonSettings.Fields.PerformanceAndRiskData.Options.Auto',
    },
  ],
};
